<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 구분</h5>
      <div class="writeGridContainer">
        <div v-if="isPrint" class="print-input text-right">{{ form.구분 }}</div>
        <div v-else>
          <vs-radio class="mr-4" v-model="form.구분" vs-name="점검정보_구분" vs-value="상반기" color="secondary" :disabled="board.readonly">상반기</vs-radio>
          <vs-radio v-model="form.구분" vs-name="점검정보_구분" vs-value="하반기" color="secondary" :disabled="board.readonly">하반기</vs-radio>
        </div>
      </div>
    </div>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle + ' 작업'"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FieldSelectModule,
    PhotoUploadGridModule,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle:'시설물 내부',
      form: {
        inspectionTitle:'시설물 내부',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [],

        // 상반기 또는 하반기 기본값 적용
        구분: Date.now() < new Date(new Date().getFullYear(), 6, 1) ? "상반기" : "하반기",
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '지반 침하 등에 따른 구조물 위험 여부',
          is_checked: ''
        },
        {
          id: 2,
          label: '각종 균열 및 철근 노출 여부',
          is_checked: ''
        },
        {
          id: 3,
          label: '천정 및 바닥 마감재 탈락 여부',
          is_checked: ''
        },
        {
          id: 4,
          label: '창호 유리 안전 상태',
          is_checked: ''
        },
        {
          id: 5,
          label: '비상구 및 이동통로 계단천장 벽체 누수유무',
          is_checked: ''
        },
        {
          id: 6,
          label: '비상구 및 이동통로 계단 난간 상태',
          is_checked: ''
        },
        {
          id: 7,
          label: '비상구 및 이동통로 벽변 균열 및 콘크리트 탈락 상태',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상구 및 이동통로 개폐문 및 비상차량확보 상태',
          is_checked: ''
        },

      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
